import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";

const TabSelector = ({ addTab, existingTabs, options }) => {
    const [showMenu, setShowMenu] = useState(false);

    const toggleMenu = () => {
        setShowMenu(!showMenu);
    };

    const optionList = options.reduce((arr, o, i) => {
        if (existingTabs.includes(o.value)) {
            return arr;
        }

        arr.push(
            <li key={`tab-option_${i}`}>
                <button
                    className="button -text"
                    onClick={() => {
                        addTab(o);
                    }}
                >
                    {o.text}
                </button>
            </li>
        );

        return arr;
    }, []);

    if (optionList.length <= 0) {
        return null;
    }

    return (
        <div className="tab-selector">
            <button className="button -primary -small" onClick={toggleMenu}>
                <FontAwesomeIcon icon={faChevronDown} /> Add
            </button>
            {showMenu && <ul className="dropdown">{optionList}</ul>}
        </div>
    );
};

export default TabSelector;
